var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import StudentReportTable from '@/components/student-report-table/StudentReportTable';
import { Lvs as LvsModel } from '@/models/Lvs';
import LoaderCard from '@/components/loader-card/LoaderCard';
import AlertCard from '@/components/alert-card/AlertCard';
import ErrorHandler from '@/support/ErrorHandler';
import { sortBy } from 'lodash';
let Lvs = class Lvs extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.areas = [];
        this.revealAll = false;
    }
    mounted() {
        this.fetchUserLvs();
    }
    handleRevealAll() {
        this.revealAll = !this.revealAll;
    }
    get hasAreas() {
        return !!this.areas.length;
    }
    sortAreas() {
        this.areas = this.areas.map((area) => {
            area.topics = sortBy(area.topics, (topic) => topic.name);
            return area;
        });
    }
    async fetchUserLvs() {
        this.isLoading = true;
        new LvsModel()
            .filter({ users: [this.student.id] })
            .all()
            .then((result) => {
            this.areas = result;
            this.sortAreas();
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoading = false;
        });
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Lvs.prototype, "student", void 0);
Lvs = __decorate([
    Component({
        components: {
            StudentReportTable,
            LoaderCard,
            AlertCard,
        },
    })
], Lvs);
export default Lvs;
